var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIconMediumOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148592",
    "data-name": "Rectangle 148592",
    width: 30,
    height: 30,
    transform: "translate(0.004)",
    fill: "#ff411a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "save",
    transform: "translate(-0.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_34",
    "data-name": "Subtraction 34",
    d: "M13.75,27.5A13.753,13.753,0,0,1,4.026,4.028,13.751,13.751,0,0,1,23.474,23.476,13.665,13.665,0,0,1,13.75,27.5ZM13.3,20.125a26.713,26.713,0,0,1-1.9,3.238c-.342.5-.734,1.042-1.167,1.6a11.637,11.637,0,0,0,3.515.542,11.847,11.847,0,0,0,1.637-.117v-.008a11.745,11.745,0,0,0,.481-23.186A11.736,11.736,0,0,0,2.679,9.822,11.694,11.694,0,0,0,8.106,24.049a53.087,53.087,0,0,0,3.318-5.178c-.155-.173-.312-.366-.466-.575a13.383,13.383,0,0,1-2.3-6.421,11.781,11.781,0,0,1,.671-5.883,2.937,2.937,0,0,1,2.405-1.98c.059,0,.124-.007.192-.007a2.522,2.522,0,0,1,1.808.765c1.827,1.788,1.761,6.249,1.647,8.083a17.6,17.6,0,0,1-1.193,5.2,1.1,1.1,0,0,0,.146.01,1.337,1.337,0,0,0,.281-.032c1.649-.34,3.585-3.349,4.088-5.613A2.768,2.768,0,0,0,18.58,10.3a.618.618,0,0,0-.379-.284A1.093,1.093,0,0,0,18.079,10a.956.956,0,0,0-.563.182A1.11,1.11,0,0,1,16,9.8a1.105,1.105,0,0,1,.391-1.52,3.075,3.075,0,0,1,1.68-.5,3.186,3.186,0,0,1,.51.041,2.84,2.84,0,0,1,1.837,1.23,4.694,4.694,0,0,1,.458,3.818c-.588,2.685-2.926,6.724-5.787,7.326a3.6,3.6,0,0,1-.749.08,3.535,3.535,0,0,1-1.039-.156ZM11.936,6.209c-.089.007-.319.162-.561.7-.833,1.857-.833,6.517,1.064,9.591a15.006,15.006,0,0,0,.772-3.772l-.007-.008c.216-3.5-.361-5.763-.989-6.383a.344.344,0,0,0-.246-.128Z",
    transform: "translate(0.999 0.998)",
    fill: "#ff411a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconMediumOutlined);
export default __webpack_public_path__ + "static/media/logo-icon-medium-outlined.69200692.svg";
export { ForwardRef as ReactComponent };